import React from "react";
import "maplibre-gl/dist/maplibre-gl.css";
import { LocalContentProvider } from "./context";
import Map from "./Map";

const LocalContent = () => (
  <LocalContentProvider>
    <Map />
  </LocalContentProvider>
);

export default LocalContent;
